"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExpertHandymanSolutionsForYourHome() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: img1Ref,
    isVisible: isImg1Visible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: img2Ref,
    isVisible: isImg2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: img3Ref,
    isVisible: isImg3Visible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section data-section-id="226495" id="our-care-expertise" className="relative w-full min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden py-20 lg:py-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/handyman_service_background.png)]">
      <div className="absolute inset-0 bg-background/80 z-0" />
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10 z-0" style={{
      backgroundImage: "linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
      backgroundSize: "50px 50px"
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid gap-12 items-center !text-[rgba(24,31,37,0.57)] !bg-[rgba(206,212,218,1)] lg:grid-cols-12 lg:gap-8">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-default font-bold text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] tracking-tighter text-foreground uppercase leading-[0.95] max-w-3xl">
              Compassion <br className="hidden sm:block" />
              In Every Touch.
            </h1>
            
            <p className="mt-8 text-lg sm:text-xl text-muted-foreground max-w-xl font-default leading-relaxed">
              Cynthylee Health Care provides a holistic approach to home care in Brighton & Hove. We believe dignity is at the heart of every service, ensuring your loved ones receive premium, professional support.
            </p>
            
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/ContactPage">
                <Button size="lg" className="group h-14 px-8 text-base rounded-lg bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg">
                  Book a Consultation
                  <ArrowRight className="ml-2 size-5 transition-transform duration-300 group-hover:translate-x-1" />
                </Button>
              </Link>
              <Link to="/ServicesPage">
                <Button variant="outline" size="lg" className="h-14 px-8 text-base rounded-lg border-2 border-primary text-primary hover:bg-accent">
                  Our Care Services
                </Button>
              </Link>
            </div>
            
            {}
            <div className="mt-12 pt-8 border-t border-border/50 flex items-center gap-8">
              <div>
                <p className="font-default font-bold text-3xl text-primary">CQC</p>
                <p className="text-sm text-muted-foreground font-default uppercase tracking-wider mt-1">Registered Provider</p>
              </div>
              <div className="w-px h-12 bg-border/50"></div>
              <div>
                <p className="font-default font-bold text-3xl text-primary">100%</p>
                <p className="text-sm text-muted-foreground font-default uppercase tracking-wider mt-1">Dignity Focused</p>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative h-[600px] xl:h-[700px] w-full hidden lg:block">
            
            {}
            <div ref={img1Ref} className={`absolute top-0 right-0 w-[65%] h-[350px] z-0 transition-all duration-1000 delay-100 ease-out ${isImg1Visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-8"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/caregiver_holding_hands.png" alt="Close-up of caregiver holding hands with elderly patient" className="w-full h-full object-cover rounded-lg shadow-md grayscale-[20%] hover:grayscale-0 transition-all duration-500" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/1.jpeg" />
            </div>

            {}
            <div ref={img2Ref} className={`absolute top-[22%] left-0 w-[85%] h-[420px] z-10 shadow-2xl border-[12px] border-background rounded-lg transition-all duration-1000 delay-300 ease-out ${isImg2Visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/modern_home_care_setting.png" alt="Compassionate caregiver assisting a senior in a bright living room" className="w-full h-full object-cover rounded-md" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_5.webp" />
            </div>

            {}
            <div ref={img3Ref} className={`absolute bottom-[5%] right-[5%] w-[55%] h-[280px] z-20 shadow-xl border-[12px] border-background rounded-lg transition-all duration-1000 delay-500 ease-out ${isImg3Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/healthcare_professional_smile.png" alt="Smiling healthcare professional in uniform" className="w-full h-full object-cover rounded-md" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_0.webp" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/2.jpeg" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/8.jpeg" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/3.jpeg" />
            </div>
            
          </div>

          {}
          <div className="lg:hidden mt-12 relative w-full aspect-[4/3]">
             <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/modern_home_care_setting.png" alt="Compassionate caregiver assisting a senior" className="w-full h-full object-cover shadow-xl rounded-lg" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_5.webp" />
              <div className="absolute -bottom-6 -right-4 w-2/3 aspect-video border-8 border-background shadow-lg rounded-lg overflow-hidden">
                 <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/caregiver_holding_hands.png" alt="Caregiver hands" className="w-full h-full object-contain !text-[rgba(24,31,37,1)] rounded-tl-[21px] rounded-tr-[21px] rounded-br-[21px] rounded-bl-[21px] !border-1 border-[rgb(24,31,37)] !border-none !opacity-[1] !bg-[rgba(0,0,0,0.6)]" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/3.jpeg" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_5.webp" />
              </div>
          </div>

        </div>
      </div>
    </section>;
}